import React from 'react';
import { motion } from 'framer-motion';
import { FaHotdog, FaTruck } from 'react-icons/fa';
import HeroTitle from './HeroTitle';
import VerticalCutReveal from '../animations/VerticalCutReveal';

export default function HeroContent() {
  const scrollToMenu = () => {
    document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      className="space-y-8"
    >
      <div className="inline-block px-4 py-1 bg-red-100 border-2 border-red-700/30 rounded-full">
        <span className="text-sm font-medium text-red-700">Siden 1964</span>
      </div>
      
      <HeroTitle />
      
      <div className="text-xl text-gray-600 max-w-lg text-left leading-relaxed">
        <VerticalCutReveal
          splitBy="words"
          staggerDuration={0.1}
          transition={{
            type: "spring",
            stiffness: 200,
            damping: 20,
            delay: 0.5 // Add a delay to ensure the animation starts after the component mounts
          }}
          containerClassName="block" // Add this to ensure proper text wrapping
        >
          Oplev smagen af tradition og kvalitet i hvert bid. 
          Håndlavede hotdogs med de bedste danske råvarer.
        </VerticalCutReveal>
      </div>

      <div className="flex flex-col sm:flex-row gap-4 pt-4">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={scrollToMenu}
          className="inline-flex items-center px-8 py-4 bg-red-700 text-white rounded-full font-medium
                     shadow-xl shadow-red-700/20 hover:bg-red-800 transition-colors"
        >
          <span>Se Vores Menu</span>
          <FaHotdog className="ml-2 w-5 h-5" />
        </motion.button>

        <motion.a
          href="https://bchudlejning.dk/"
          target="_blank"
          rel="noopener noreferrer"
          className="group relative inline-flex items-center px-8 py-4 bg-white text-red-700 rounded-full font-medium
                     border-2 border-red-700/30 shadow-xl shadow-red-700/10 
                     hover:bg-red-50 transition-colors overflow-hidden"
          whileHover="hover"
        >
          <span className="relative z-10">Lej En Pølsevogn</span>
          <motion.div
            className="relative z-10 ml-2"
            variants={{
              hover: {
                x: 100,
                rotate: -25,
                transition: {
                  type: "spring",
                  stiffness: 200,
                  damping: 10
                }
              }
            }}
          >
            <FaTruck className="w-5 h-5" />
          </motion.div>
          
          <motion.div
            className="absolute inset-0 w-full bg-gradient-to-r from-transparent via-red-100 to-transparent"
            variants={{
              hover: {
                x: [null, "-100%"],
                transition: {
                  duration: 0.8,
                  repeat: Infinity,
                  ease: "linear"
                }
              }
            }}
          />
        </motion.a>
      </div>
    </motion.div>
  );
}